/**
 * Reads an uploaded image and downsizes it to a JPEG data URL.
 *
 * Phone photos are 3–8 MB; stored as-is a handful would fill browser storage.
 * 1400px on the long side at 0.82 quality is sharp on a retina card and lands
 * around 150–250 KB.
 */
export function imageFileToDataUrl(file: File, maxSide = 1400, quality = 0.82): Promise<string> {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith('image/')) {
      reject(new Error('Filen är inte en bild.'));
      return;
    }

    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Kunde inte läsa filen.'));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error('Bildformatet stöds inte.'));
      img.onload = () => {
        const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(img.width * scale);
        canvas.height = Math.round(img.height * scale);
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject(new Error('Kunde inte bearbeta bilden.'));
          return;
        }
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL('image/jpeg', quality));
      };
      img.src = String(reader.result);
    };
    reader.readAsDataURL(file);
  });
}

export const slugify = (value: string): string =>
  value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
